import { createClient } from 'contentful';
import config from '../../config';
export function getContentfulClient() {
  var _config = config[process.env.CHEGG_ENV || 'test'],
    contentful = _config.contentful,
    contentfulPreview = _config.contentfulPreview,
    env = _config.env;
  var isPreviewMode = window.location.search.includes('previewmode=true');
  var currentConfig = isPreviewMode && env == 'test' ? contentfulPreview : contentful;
  var host = currentConfig.host,
    environment = currentConfig.environment,
    space = currentConfig.space,
    accessToken = currentConfig.accessToken;
  return createClient({
    host: host,
    space: space,
    environment: environment,
    accessToken: accessToken
  });
}
export function getContentfulData(query) {
  return getContentfulClient().getEntries(query);
}